import React from 'react';
import PropTypes from 'prop-types';
import {WithCheckLoggedIn} from './WithCheckLoggedIn';
import {graphqlError} from 'components/GraphQLError';
import {WithOrganization} from '../../api/organizations/withOrganization';


export class RequireScope extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
        fallback: PropTypes.func,
        loading: PropTypes.func,
        permissions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
        requireSuperUser: PropTypes.bool,
        scope: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
        onError: PropTypes.func,
        onLoggedInStatusChanged: PropTypes.func,
        sneakPeekForOrganizations: PropTypes.arrayOf(PropTypes.string)
    };

    static defaultProps = {
        fallback: () => null,
        loading: () => null,
        onLoggedInStatusChanged: () => null,
        onError: graphqlError,
        sneakPeekForOrganizations: []
    };

    toArray = (arrayOrSingleElement) => {
        if (!arrayOrSingleElement) {
            return [];
        }

        if (Array.isArray(arrayOrSingleElement)) {
            return arrayOrSingleElement;
        }
        return [arrayOrSingleElement];
    };

    isRestricted = () => {
        const {scope, permissions} = this.props;
        return this.toArray(scope).length > 0 || this.toArray(permissions).length > 0;
    };

    hasOneOfPermissions = (userPermissions) => {
        const requiredPermissions = this.toArray(this.props.permissions);
        return userPermissions.filter(value => requiredPermissions.includes(value)).length;
    };

    isSuperUser = (user) => {
        return user.isSuperUser;
    };

    sneakPeekAllowedForOrganization = (organization) => {
        return this.props.sneakPeekForOrganizations.includes(organization.id);
    };

    render() {
        return (
            <WithOrganization>
                {({loading: loadingOrganization, organization}) => (
                    <WithCheckLoggedIn onLoggedInStatusChanged={this.props.onLoggedInStatusChanged}>
                        {({isLoggedIn, loading, user}) => {
                            if (loading || loadingOrganization) {
                                return this.props.loading();
                            }

                            if (!isLoggedIn || !user) {
                                return this.props.fallback();
                            }

                            if (this.props.requireSuperUser && !this.isSuperUser(user) && !this.sneakPeekAllowedForOrganization(organization)) {
                                return this.props.fallback();
                            }

                            if (!this.isRestricted()) {
                                return this.props.children();
                            }

                            if (this.hasOneOfPermissions(user.permissions)) {
                                return this.props.children();
                            }

                            return this.props.fallback();
                        }}
                    </WithCheckLoggedIn>
                )}
            </WithOrganization>
        );
    }
}

export function requireScope(WrappedComponent, options = {}) {
    const RequireScopeHoc = (props) => (
        <RequireScope
            scope={options.scope} permissions={options.permissions}
            requireSuperUser={options.requireSuperUser}>
            {() => <WrappedComponent {...props}/>}
        </RequireScope>
    );
    return RequireScopeHoc;
}
